import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15bdba72"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"color":"red","font-size":"14px","margin-bottom":"15px"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 2 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 4 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 6 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 8 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 10 }
const _hoisted_16 = { key: 11 }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { key: 13 }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { key: 15 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { key: 17 }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 19 }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 21 }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { key: 23 }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { key: 25 }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { key: 27 }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { key: 29 }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { key: 31 }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { key: 33 }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "公司名称", -1))
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "执行人姓名", -1))
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = { key: 1 }
const _hoisted_66 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_order_summary_time = _resolveComponent("order-summary-time")!
  const _component_miezz_menu_tab = _resolveComponent("miezz-menu-tab")!
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_miezz_button = _resolveComponent("miezz-button")!
  const _component_miezz_text_ellipsis = _resolveComponent("miezz-text-ellipsis")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_miezz_card = _resolveComponent("miezz-card")!
  const _component_miezz_common_history = _resolveComponent("miezz-common-history")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_order_supplier = _resolveComponent("order-supplier")!
  const _component_miezz_upload = _resolveComponent("miezz-upload")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.menuTab)
      ? (_openBlock(), _createBlock(_component_miezz_menu_tab, {
          key: 0,
          modelValue: _ctx.menuTab,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.menuTab) = $event))
        }, {
          center: _withCtx(() => [
            _createVNode(_component_order_summary_time, {
              id: _ctx.list.Data?.OrderId
            }, null, 8, ["id"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_miezz_card, null, {
      default: _withCtx(() => [
        (_ctx.list.Data?.UseThreeApiService)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_ctx.list.Data.OrderId)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _createTextVNode(" 在"),
                    _createElementVNode("a", {
                      href: `/#/order/main-bill/edit/${_ctx.list.Data.OrderId}?backUrl=${_ctx.$route.fullPath}`
                    }, "主单信息", 8, _hoisted_3),
                    _createTextVNode("中填入提单号码后，此处填写箱号信息可自动获取相应信息（标题绿色） ")
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, "在主单信息中填入提单号码后，此处填写箱号信息可自动获取相应信息（标题绿色）"))
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_miezz_page_list, {
          modelValue: _ctx.list,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.list) = $event)),
          onHandleGet: _ctx.handleGet,
          onHandleTopButtonClick: _ctx.handleTopButtonClick,
          onHandleRowButtonClick: _ctx.handleRowButtonClick,
          onHandleBottomButtonClick: _ctx.handleTitleClick
        }, {
          "dynamic-search-customize": _withCtx(({ model }) => [
            (model.Where.Prop == 'DynamicSearch_Color')
              ? (_openBlock(), _createBlock(_component_miezz_select, {
                  key: 0,
                  modelValue: model.Where.Value,
                  "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                  options: _ctx.colors,
                  clearable: "",
                  style: _normalizeStyle(`background-color: ${model.Where.Value}`),
                  class: "select-color"
                }, {
                  default: _withCtx(({ model }) => [
                    _createElementVNode("div", {
                      style: _normalizeStyle(`background-color: ${model.value}; margin: 0px -27px 0px -15px; color: #FFF`)
                    }, _toDisplayString(model.value), 5)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "options", "style"]))
              : _createCommentVNode("", true)
          ]),
          "column-header": _withCtx(({ model }) => [
            _createElementVNode("div", {
              style: _normalizeStyle(_ctx.list.Data?.UseThreeApiService && _ctx.threeApiProps.contains(model.Prop) ? 'color: green' : '')
            }, [
              _createTextVNode(_toDisplayString(model.Label) + " ", 1),
              (_ctx.pageSize == 9999999 && _ctx.batchEditProps.contains(model.Prop))
                ? (_openBlock(), _createBlock(_component_miezz_button, {
                    key: 0,
                    model: _ctx.btnBatchEdit,
                    onHandleClick: (arg1, arg2) => _ctx.handleTitleClick(arg1, arg2, model.Prop)
                  }, null, 8, ["model", "onHandleClick"]))
                : _createCommentVNode("", true)
            ], 4)
          ]),
          column: _withCtx(({ model, row }) => [
            (model.Prop == 'Color')
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  _createVNode(_component_miezz_button, {
                    model: {
            Code: 'mark',
            Type: 'color',
          },
                    color: row.Color,
                    onHandleClick: (arg1, arg2) => _ctx.handleRowButtonClick(arg1, row, arg2)
                  }, null, 8, ["color", "onHandleClick"])
                ]))
              : _createCommentVNode("", true),
            (model.Prop == 'OrderCode' && row.Order)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                }, [
                  _createVNode(_component_miezz_text_ellipsis, {
                    text: row.OrderCode ?? '暂无数据'
                  }, null, 8, ["text"])
                ], 8, _hoisted_6))
              : (model.Prop == 'ClientCompany')
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(row.ClientCompany), 1))
                : _createCommentVNode("", true),
            (model.Prop == 'ContainerTypeLabel' && _ctx.canEdit)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 3,
                  onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                }, [
                  _createVNode(_component_miezz_text_ellipsis, {
                    text: row.ContainerTypeLabel ?? '暂无数据',
                    style: _normalizeStyle(row.ContainerTypeLabel ? 'color: #409eff' : '')
                  }, null, 8, ["text", "style"])
                ], 8, _hoisted_8))
              : (model.Prop == 'ContainerTypeLabel')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_miezz_text_ellipsis, {
                      text: row.ContainerTypeLabel ?? '暂无数据'
                    }, null, 8, ["text"])
                  ]))
                : (model.Prop == 'CarryPlanTime' && _ctx.canEdit)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 5,
                      onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                    }, [
                      _createVNode(_component_miezz_text_ellipsis, {
                        text: _ctx.formatTime(row.CarryPlanTime),
                        style: _normalizeStyle(row.CarryPlanTime ? 'color: #409eff' : '')
                      }, null, 8, ["text", "style"])
                    ], 8, _hoisted_10))
                  : (model.Prop == 'CarryPlanTime')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: _ctx.formatTime(row.CarryPlanTime)
                        }, null, 8, ["text"])
                      ]))
                    : (
          model.Prop == 'Addresses' &&
          (_ctx.canEdit || (row.Addresses && row.Addresses.length > 0))
        )
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 7,
                          onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                        }, [
                          _createVNode(_component_miezz_text_ellipsis, {
                            text: row.Addresses.length > 0 &&
            row.Addresses.any(
              (it) => it.PlanTime && it.CompanyAddress?.Address
            )
            ? '查看详情'
            : '暂无数据'
            ,
                            style: _normalizeStyle(row.Addresses.length > 0 &&
              row.Addresses.any(
                (it) => it.PlanTime && it.CompanyAddress?.Address
              )
              ? 'color: #409EFF'
              : ''
              )
                          }, null, 8, ["text", "style"])
                        ], 8, _hoisted_12))
                      : (model.Prop == 'Addresses')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createVNode(_component_miezz_text_ellipsis, { text: "暂无数据" })
                          ]))
                        : (model.Prop == 'ArrivalTime' && _ctx.canEdit)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 9,
                              onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                            }, [
                              _createVNode(_component_miezz_text_ellipsis, {
                                text: _ctx.formatTime(row.ArrivalTime) +
            (row.LeaveTime ? `/${_ctx.formatTime(row.LeaveTime)}` : '')
            ,
                                style: _normalizeStyle(row.ArrivalTime || row.LeaveTime ? 'color: #409eff' : '')
                              }, null, 8, ["text", "style"])
                            ], 8, _hoisted_14))
                          : (model.Prop == 'ArrivalTime')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createVNode(_component_miezz_text_ellipsis, {
                                  text: _ctx.formatTime(row.ArrivalTime) +
            (row.LeaveTime ? `/${_ctx.formatTime(row.LeaveTime)}` : '')
            
                                }, null, 8, ["text"])
                              ]))
                            : (
          model.Prop == 'SupplierLabel' &&
          (_ctx.logier?.CompanyType == _ctx.EnumCompanyType.Customer ||
            _ctx.logier?.DisabledReadSupplier)
        )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  _createVNode(_component_miezz_text_ellipsis, {
                                    text: _ctx.logier.ServiceProviderCompanyNameZh,
                                    style: _normalizeStyle(_ctx.logier.ServiceProviderCompanyNameZh ? 'color: #409eff' : '')
                                  }, null, 8, ["text", "style"])
                                ]))
                              : (
          model.Prop == 'SupplierLabel' &&
          (_ctx.canEdit || row.SupplierLabel != '暂无数据')
        )
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 12,
                                    onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                                  }, [
                                    _createVNode(_component_miezz_text_ellipsis, {
                                      text: row.SupplierLabel ? row.SupplierLabel : '暂无数据',
                                      style: _normalizeStyle(row.SupplierLabel && row.SupplierLabel != '暂无数据'
            ? 'color: #409eff'
            : ''
            )
                                    }, null, 8, ["text", "style"])
                                  ], 8, _hoisted_17))
                                : (model.Prop == 'SupplierLabel')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                      _createVNode(_component_miezz_text_ellipsis, { text: "暂无数据" })
                                    ]))
                                  : (
          model.Prop == 'ExecutorLabel' &&
          (_ctx.canEdit || (row.ExecutorLabel && row.ExecutorLabel != '暂无数据'))
        )
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 14,
                                        onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                                      }, [
                                        _createVNode(_component_miezz_text_ellipsis, {
                                          text: row.ExecutorLabel,
                                          style: _normalizeStyle(row.ExecutorLabel && row.ExecutorLabel != '暂无数据'
            ? 'color: #409eff'
            : ''
            )
                                        }, null, 8, ["text", "style"])
                                      ], 8, _hoisted_19))
                                    : (model.Prop == 'ExecutorLabel')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                          _createVNode(_component_miezz_text_ellipsis, {
                                            text: row.ExecutorLabel
                                          }, null, 8, ["text"])
                                        ]))
                                      : (
          model.Prop == 'CarryContainerAreaLabel' &&
          _ctx.canEdit
        )
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 16,
                                            onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                                          }, [
                                            _createVNode(_component_miezz_text_ellipsis, {
                                              text: row.CarryContainerAreaLabel ?? '暂无数据',
                                              style: _normalizeStyle(row.CarryContainerAreaLabel ? 'color: #409eff' : '')
                                            }, null, 8, ["text", "style"])
                                          ], 8, _hoisted_21))
                                        : (model.Prop == 'CarryContainerAreaLabel')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                              _createVNode(_component_miezz_text_ellipsis, {
                                                text: row.CarryContainerAreaLabel ?? '暂无数据'
                                              }, null, 8, ["text"])
                                            ]))
                                          : (
          model.Prop == 'PlanCarryContainerTime' &&
          _ctx.canEdit
        )
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 18,
                                                onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                                              }, [
                                                _createVNode(_component_miezz_text_ellipsis, {
                                                  text: _ctx.formatTime(row.PlanCarryContainerTime),
                                                  style: _normalizeStyle(row.PlanCarryContainerTime ? 'color: #409eff' : '')
                                                }, null, 8, ["text", "style"])
                                              ], 8, _hoisted_23))
                                            : (model.Prop == 'PlanCarryContainerTime')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                                  _createVNode(_component_miezz_text_ellipsis, {
                                                    text: _ctx.formatTime(row.PlanCarryContainerTime)
                                                  }, null, 8, ["text"])
                                                ]))
                                              : (
          model.Prop == 'CarryContainerTime' &&
          _ctx.canEdit
        )
                                                ? (_openBlock(), _createElementBlock("a", {
                                                    key: 20,
                                                    onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                                                  }, [
                                                    _createVNode(_component_miezz_text_ellipsis, {
                                                      text: _ctx.formatTime(row.CarryContainerTime),
                                                      style: _normalizeStyle(row.CarryContainerTime ? 'color: #409eff' : '')
                                                    }, null, 8, ["text", "style"])
                                                  ], 8, _hoisted_25))
                                                : (model.Prop == 'CarryContainerTime')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                                      _createVNode(_component_miezz_text_ellipsis, {
                                                        text: _ctx.formatTime(row.CarryContainerTime)
                                                      }, null, 8, ["text"])
                                                    ]))
                                                  : (
          model.Prop == 'StopAddress' &&
          (_ctx.canEdit ||
            row.StopAddress ||
            row.StopAddressCarBoardNumber ||
            (row.StopAddresses && row.StopAddresses.length > 0))
        )
                                                    ? (_openBlock(), _createElementBlock("a", {
                                                        key: 22,
                                                        onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                                                      }, [
                                                        _createVNode(_component_miezz_text_ellipsis, {
                                                          text: row.StopAddress ||
            row.StopAddressCarBoardNumber ||
            (row.StopAddresses && row.StopAddresses.length > 0)
            ? '查看详情'
            : '暂无数据'
            ,
                                                          style: _normalizeStyle(row.StopAddress ||
              row.StopAddressCarBoardNumber ||
              (row.StopAddresses && row.StopAddresses.length > 0)
              ? 'color: #409EFF'
              : ''
              )
                                                        }, null, 8, ["text", "style"])
                                                      ], 8, _hoisted_27))
                                                    : (model.Prop == 'StopAddress')
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                                          _createVNode(_component_miezz_text_ellipsis, { text: "暂无数据" })
                                                        ]))
                                                      : (
          model.Prop == 'IntoPortWharfLabel' &&
          _ctx.canEdit
        )
                                                        ? (_openBlock(), _createElementBlock("a", {
                                                            key: 24,
                                                            onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                                                          }, [
                                                            _createVNode(_component_miezz_text_ellipsis, {
                                                              text: row.IntoPortWharfLabel ?? '暂无数据',
                                                              style: _normalizeStyle(row.IntoPortWharfLabel ? 'color: #409eff' : '')
                                                            }, null, 8, ["text", "style"])
                                                          ], 8, _hoisted_29))
                                                        : (model.Prop == 'IntoPortWharfLabel')
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                              _createVNode(_component_miezz_text_ellipsis, {
                                                                text: row.IntoPortWharfLabel ?? '暂无数据'
                                                              }, null, 8, ["text"])
                                                            ]))
                                                          : (
          model.Prop == 'BackContainerTime' &&
          _ctx.canEdit
        )
                                                            ? (_openBlock(), _createElementBlock("a", {
                                                                key: 26,
                                                                onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                                                              }, [
                                                                _createVNode(_component_miezz_text_ellipsis, {
                                                                  text: _ctx.formatTime(row.BackContainerTime),
                                                                  style: _normalizeStyle(row.BackContainerTime ? 'color: #409eff' : '')
                                                                }, null, 8, ["text", "style"])
                                                              ], 8, _hoisted_31))
                                                            : (model.Prop == 'BackContainerTime')
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                                                  _createVNode(_component_miezz_text_ellipsis, {
                                                                    text: _ctx.formatTime(row.BackContainerTime)
                                                                  }, null, 8, ["text"])
                                                                ]))
                                                              : (model.Prop == 'ContainerNo' && _ctx.canEdit)
                                                                ? (_openBlock(), _createElementBlock("a", {
                                                                    key: 28,
                                                                    onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                                                                  }, [
                                                                    _createVNode(_component_miezz_text_ellipsis, {
                                                                      text: row.ContainerNo && row.Tare
            ? `${row.ContainerNo}/${row.Tare}`
            : row.ContainerNo
              ? row.ContainerNo
              : '暂无数据'
            ,
                                                                      style: _normalizeStyle(row.ContainerNo || row.Tare ? 'color: #409eff' : '')
                                                                    }, null, 8, ["text", "style"])
                                                                  ], 8, _hoisted_33))
                                                                : (model.Prop == 'ContainerNo')
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                                                      _createVNode(_component_miezz_text_ellipsis, {
                                                                        text: row.ContainerNo && row.Tare
            ? `${row.ContainerNo}/${row.Tare}`
            : row.ContainerNo
              ? row.ContainerNo
              : '暂无数据'
            
                                                                      }, null, 8, ["text"])
                                                                    ]))
                                                                  : (
          model.Prop == 'SealNo' &&
          _ctx.canEdit
        )
                                                                    ? (_openBlock(), _createElementBlock("a", {
                                                                        key: 30,
                                                                        onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                                                                      }, [
                                                                        _createVNode(_component_miezz_text_ellipsis, {
                                                                          text: row.SealNo ?? '暂无数据',
                                                                          style: _normalizeStyle(row.SealNo ? 'color: #409eff' : '')
                                                                        }, null, 8, ["text", "style"])
                                                                      ], 8, _hoisted_35))
                                                                    : (model.Prop == 'SealNo')
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                                                          _createVNode(_component_miezz_text_ellipsis, {
                                                                            text: row.SealNo ?? '暂无数据'
                                                                          }, null, 8, ["text"])
                                                                        ]))
                                                                      : (
          model.Prop == 'Files' &&
          (_ctx.canEdit ||
            row.ContainerNoFile ||
            row.SealNoFile ||
            row.Files.length > 0)
        )
                                                                        ? (_openBlock(), _createElementBlock("a", {
                                                                            key: 32,
                                                                            onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                                                                          }, [
                                                                            _createVNode(_component_miezz_text_ellipsis, {
                                                                              text: row.ContainerNoFile ||
            row.SealNoFile ||
            (row.Files && row.Files.length > 0)
            ? '查看详情'
            : '暂无数据'
            ,
                                                                              style: _normalizeStyle(row.ContainerNoFile ||
              row.SealNoFile ||
              (row.Files && row.Files.length > 0) > 0
              ? 'color: #409EFF'
              : ''
              )
                                                                            }, null, 8, ["text", "style"])
                                                                          ], 8, _hoisted_37))
                                                                        : (model.Prop == 'Files')
                                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                                                              _createVNode(_component_miezz_text_ellipsis, { text: "暂无数据" })
                                                                            ]))
                                                                          : (model.Prop == 'Process')
                                                                            ? (_openBlock(), _createElementBlock("a", {
                                                                                key: 34,
                                                                                onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                                                                              }, [
                                                                                _createVNode(_component_miezz_text_ellipsis, {
                                                                                  text: "查看详情",
                                                                                  style: {"color":"#409eff"}
                                                                                })
                                                                              ], 8, _hoisted_39))
                                                                            : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "onHandleGet", "onHandleTopButtonClick", "onHandleRowButtonClick", "onHandleBottomButtonClick"]),
        (_ctx.canAdd && _ctx.pageSize)
          ? (_openBlock(), _createBlock(_component_miezz_button, {
              key: 1,
              style: {"color":"#fe995b"},
              model: _ctx.btnAdd,
              onHandleClick: _ctx.handleTopButtonClick
            }, null, 8, ["model", "onHandleClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.logier?.CompanyType != _ctx.EnumCompanyType.Customer && !_ctx.disabledHistories)
      ? (_openBlock(), _createBlock(_component_miezz_common_history, {
          key: 1,
          modelValue: _ctx.histories,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.histories) = $event))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalContainerType,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modalContainerType) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          modelValue: _ctx.formContainerType,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formContainerType) = $event)),
          ref: "ref-form-container-type"
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'ContainerTypeId')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: item.Label,
                  prop: item.Prop
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_select, {
                      modelValue: _ctx.formContainerType.Data.ContainerTypeId,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formContainerType.Data.ContainerTypeId) = $event)),
                      label: _ctx.formContainerType.Data.ContainerTypeLabel,
                      "onUpdate:label": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formContainerType.Data.ContainerTypeLabel) = $event)),
                      options: _ctx.containerTypes
                    }, null, 8, ["modelValue", "label", "options"])
                  ]),
                  _: 2
                }, 1032, ["label", "prop"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalCarryPlanTime,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modalCarryPlanTime) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          modelValue: _ctx.formCarryPlanTime,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formCarryPlanTime) = $event)),
          ref: "ref-form-carry-plan-time"
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'CarryPlanTime')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: item.Label,
                  prop: item.Prop
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.formCarryPlanTime.Data.CarryPlanTime,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formCarryPlanTime.Data.CarryPlanTime) = $event)),
                      type: "datetime",
                      format: "YYYY/MM/DD HH:mm",
                      "value-format": "YYYY/MM/DD HH:mm",
                      class: "form-item-date"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["label", "prop"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalAddresses,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.modalAddresses) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          modelValue: _ctx.formAddresses,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formAddresses) = $event)),
          ref: "ref-form-addresses"
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'Addresses')
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formAddresses.Data.Addresses, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", { key: i }, [
                      _createVNode(_component_el_form_item, {
                        label: "公司名称",
                        prop: `Addresses[${i}].CompanyAddress.CompanyName`,
                        rules: _ctx.formAddresses.Rules.CompanyName
                      }, {
                        label: _withCtx(() => [
                          (i > 0 && _ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_miezz_button, {
                                key: 0,
                                model: _ctx.btnDeleteAddress,
                                onHandleClick: (arg1, arg2) => _ctx.handleDeleteAddress(i, arg2)
                              }, null, 8, ["model", "onHandleClick"]))
                            : _createCommentVNode("", true),
                          _hoisted_41
                        ]),
                        default: _withCtx(() => [
                          (_ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_miezz_input, {
                                key: 0,
                                modelValue: item.CompanyAddress.CompanyName,
                                "onUpdate:modelValue": ($event: any) => ((item.CompanyAddress.CompanyName) = $event),
                                "fetch-suggestions": _ctx.getConpanyNames,
                                "trigger-on-focus": true,
                                clearable: "",
                                "value-key": "CompanyName",
                                onHandleSelect: (arg1) => _ctx.handleSelectCompanyName(arg1, item)
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "fetch-suggestions", "onHandleSelect"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(item.CompanyAddress.CompanyName ?? "暂无数据"), 1))
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"]),
                      _createVNode(_component_el_form_item, {
                        label: "坐标",
                        prop: `Addresses[${i}].CompanyAddress.AreaLabel`,
                        rules: _ctx.formAddresses.Rules.AreaLabel
                      }, {
                        default: _withCtx(() => [
                          (_ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_miezz_input, {
                                key: 0,
                                modelValue: item.CompanyAddress.AreaLabel,
                                "onUpdate:modelValue": ($event: any) => ((item.CompanyAddress.AreaLabel) = $event),
                                "fetch-suggestions": _ctx.getAreas,
                                "trigger-on-focus": true,
                                clearable: "",
                                valueKey: "FullName",
                                onHandleSelect: (arg1) => _ctx.handleSelectArea(arg1, item)
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "fetch-suggestions", "onHandleSelect"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(item.CompanyAddress.AreaLabel ?? "暂无数据"), 1))
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"]),
                      _createVNode(_component_el_form_item, {
                        label: "详细地址",
                        prop: `Addresses[${i}].CompanyAddress.Address`,
                        rules: _ctx.formAddresses.Rules.Address
                      }, {
                        default: _withCtx(() => [
                          (_ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_miezz_input, {
                                key: 0,
                                modelValue: item.CompanyAddress.Address,
                                "onUpdate:modelValue": ($event: any) => ((item.CompanyAddress.Address) = $event),
                                clearable: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(item.CompanyAddress.Address ?? "暂无数据"), 1))
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"]),
                      _createVNode(_component_el_form_item, {
                        label: "计划时间",
                        prop: `Addresses[${i}].PlanTime`,
                        rules: _ctx.formAddresses.Rules.PlanTime
                      }, {
                        default: _withCtx(() => [
                          (_ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_el_date_picker, {
                                key: 0,
                                modelValue: item.PlanTime,
                                "onUpdate:modelValue": ($event: any) => ((item.PlanTime) = $event),
                                type: "datetime",
                                format: "YYYY/MM/DD HH:mm",
                                "value-format": "YYYY/MM/DD HH:mm",
                                class: "form-item-date"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_ctx.formatTime(item.PlanTime)), 1))
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"]),
                      _createVNode(_component_el_form_item, {
                        label: "货量",
                        prop: `Addresses[${i}].GoodsQuantity`,
                        rules: _ctx.formAddresses.Rules.GoodsQuantity
                      }, {
                        default: _withCtx(() => [
                          (_ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_miezz_input, {
                                key: 0,
                                modelValue: item.GoodsQuantity,
                                "onUpdate:modelValue": ($event: any) => ((item.GoodsQuantity) = $event),
                                clearable: false,
                                number: true,
                                greaterThanNumber: 0,
                                pattern: "[0-9]"
                              }, {
                                suffix: _withCtx(() => [
                                  _createTextVNode(" KGS ")
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_ctx.formatTime(item.PlanTime)), 1))
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"]),
                      _createVNode(_component_el_form_item, {
                        label: "联系人",
                        prop: `Addresses[${i}].CompanyAddress.Contact`,
                        rules: _ctx.formAddresses.Rules.Contact
                      }, {
                        default: _withCtx(() => [
                          (_ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_miezz_input, {
                                key: 0,
                                modelValue: item.CompanyAddress.Contact,
                                "onUpdate:modelValue": ($event: any) => ((item.CompanyAddress.Contact) = $event),
                                "fetch-suggestions": (arg1, arg2) => _ctx.getContacts(arg1, item, arg2)
                ,
                                "trigger-on-focus": true,
                                clearable: "",
                                "value-key": "Contact",
                                deleteOption: true,
                                onHandleSelect: (arg1) => _ctx.handleSelectContact(arg1, item),
                                onHandleDeleteOption: 
                  (arg1, arg2) => _ctx.handleDeleteContact(arg1, arg2, item)
                
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "fetch-suggestions", "onHandleSelect", "onHandleDeleteOption"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(item.CompanyAddress.Contact ?? "暂无数据"), 1))
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"]),
                      _createVNode(_component_el_form_item, {
                        label: "联系方式",
                        prop: `Addresses[${i}].CompanyAddress.ContactNumber`,
                        rules: _ctx.formAddresses.Rules.ContactNumber
                      }, {
                        default: _withCtx(() => [
                          (_ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_miezz_input, {
                                key: 0,
                                modelValue: item.CompanyAddress.ContactNumber,
                                "onUpdate:modelValue": ($event: any) => ((item.CompanyAddress.ContactNumber) = $event),
                                clearable: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(item.CompanyAddress.ContactNumber ?? "暂无数据"), 1))
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"]),
                      _createVNode(_component_el_form_item, {
                        label: "备注",
                        prop: `Addresses[${i}].CompanyAddress.Remark`,
                        rules: _ctx.formAddresses.Rules.Remark
                      }, {
                        default: _withCtx(() => [
                          (_ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_miezz_input, {
                                key: 0,
                                modelValue: item.CompanyAddress.Remark,
                                "onUpdate:modelValue": ($event: any) => ((item.CompanyAddress.Remark) = $event),
                                type: "textarea",
                                rows: 5,
                                trim: false
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(item.CompanyAddress.Remark ?? "暂无数据"), 1))
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"])
                    ]))
                  }), 128)),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      (_ctx.canEdit)
                        ? (_openBlock(), _createBlock(_component_miezz_button, {
                            key: 0,
                            model: _ctx.btnAddAddress,
                            onHandleClick: _ctx.handleTopButtonClick
                          }, null, 8, ["model", "onHandleClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalArrivalTime,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.modalArrivalTime) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          modelValue: _ctx.formArrivalTime,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formArrivalTime) = $event)),
          ref: "ref-form-arrival-time"
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'ArrivalTime')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: item.Label,
                  prop: item.Prop
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.formArrivalTime.Data.ArrivalTime,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formArrivalTime.Data.ArrivalTime) = $event)),
                      type: "datetime",
                      format: "YYYY/MM/DD HH:mm",
                      "value-format": "YYYY/MM/DD HH:mm",
                      class: "form-item-date",
                      onChange: _ctx.handleChangeArrivalTime
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  _: 2
                }, 1032, ["label", "prop"]))
              : _createCommentVNode("", true),
            (item.Prop == 'LeaveTime')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: item.Label,
                  prop: item.Prop
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.formArrivalTime.Data.LeaveTime,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formArrivalTime.Data.LeaveTime) = $event)),
                      type: "datetime",
                      format: "YYYY/MM/DD HH:mm",
                      "value-format": "YYYY/MM/DD HH:mm",
                      class: "form-item-date",
                      onChange: _ctx.handleChangeLeaveTime
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  _: 2
                }, 1032, ["label", "prop"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_order_supplier, {
      ref: "ref-order-supplier",
      show: _ctx.showSupplier,
      canEdit: _ctx.canEdit,
      onHandleSave: _ctx.handleSaveSupplier
    }, null, 8, ["show", "canEdit", "onHandleSave"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalExecutor,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.modalExecutor) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          modelValue: _ctx.formExecutor,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formExecutor) = $event)),
          ref: "ref-form-executor"
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'Executors')
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formExecutor.Data.Executors, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", { key: i }, [
                      _createVNode(_component_el_form_item, {
                        label: "执行人姓名",
                        prop: `Addresses[${i}].Executor`,
                        rules: _ctx.formExecutor.Rules.Executor
                      }, {
                        label: _withCtx(() => [
                          (i > 0 && _ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_miezz_button, {
                                key: 0,
                                model: _ctx.btnDeleteExecutor,
                                onHandleClick: (arg1, arg2) => _ctx.handleDeleteExecutor(i, arg2)
                              }, null, 8, ["model", "onHandleClick"]))
                            : _createCommentVNode("", true),
                          _hoisted_51
                        ]),
                        default: _withCtx(() => [
                          (_ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_miezz_input, {
                                key: 0,
                                modelValue: item.Executor,
                                "onUpdate:modelValue": ($event: any) => ((item.Executor) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(item.Executor ?? "暂无数据"), 1))
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"]),
                      _createVNode(_component_el_form_item, {
                        label: "执行人联系方式",
                        prop: `Addresses[${i}].ExecutorContactNumber`,
                        rules: _ctx.formExecutor.Rules.ExecutorContactNumber
                      }, {
                        default: _withCtx(() => [
                          (_ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_miezz_input, {
                                key: 0,
                                modelValue: item.ExecutorContactNumber,
                                "onUpdate:modelValue": ($event: any) => ((item.ExecutorContactNumber) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(item.ExecutorContactNumber ?? "暂无数据"), 1))
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"]),
                      _createVNode(_component_el_form_item, {
                        label: "执行人车牌号码",
                        prop: `Addresses[${i}].ExecutorLicensePlate`,
                        rules: _ctx.formExecutor.Rules.ExecutorLicensePlate
                      }, {
                        default: _withCtx(() => [
                          (_ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_miezz_input, {
                                key: 0,
                                modelValue: item.ExecutorLicensePlate,
                                "onUpdate:modelValue": ($event: any) => ((item.ExecutorLicensePlate) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(item.ExecutorLicensePlate ?? "暂无数据"), 1))
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"])
                    ]))
                  }), 128)),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      (_ctx.canEdit)
                        ? (_openBlock(), _createBlock(_component_miezz_button, {
                            key: 0,
                            model: _ctx.btnAddExecutor,
                            onHandleClick: _ctx.handleTopButtonClick
                          }, null, 8, ["model", "onHandleClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalCarryContainerArea,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.modalCarryContainerArea) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          modelValue: _ctx.formCarryContainerArea,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formCarryContainerArea) = $event)),
          ref: "ref-form-carry-container-area"
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'CarryContainerAreaLabel')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: item.Label,
                  prop: item.Prop
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_input, {
                      modelValue: _ctx.formCarryContainerArea.Data.CarryContainerAreaLabel,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formCarryContainerArea.Data.CarryContainerAreaLabel) = $event)),
                      "fetch-suggestions": _ctx.getAreas,
                      "trigger-on-focus": true,
                      clearable: "",
                      valueKey: "FullName"
                    }, null, 8, ["modelValue", "fetch-suggestions"])
                  ]),
                  _: 2
                }, 1032, ["label", "prop"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalPlanCarryContainerTime,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.modalPlanCarryContainerTime) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          modelValue: _ctx.formPlanCarryContainerTime,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formPlanCarryContainerTime) = $event)),
          ref: "ref-form-plan-carry-container-time"
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'PlanCarryContainerTime')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: item.Label,
                  prop: item.Prop
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.formPlanCarryContainerTime.Data.PlanCarryContainerTime,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formPlanCarryContainerTime.Data.PlanCarryContainerTime) = $event)),
                      type: "datetime",
                      format: "YYYY/MM/DD HH:mm",
                      "value-format": "YYYY/MM/DD HH:mm",
                      class: "form-item-date"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["label", "prop"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalCarryContainerTime,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.modalCarryContainerTime) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          modelValue: _ctx.formCarryContainerTime,
          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formCarryContainerTime) = $event)),
          ref: "ref-form-carry-container-time"
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'CarryContainerTime')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: item.Label,
                  prop: item.Prop
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.formCarryContainerTime.Data.CarryContainerTime,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formCarryContainerTime.Data.CarryContainerTime) = $event)),
                      type: "datetime",
                      format: "YYYY/MM/DD HH:mm",
                      "value-format": "YYYY/MM/DD HH:mm",
                      class: "form-item-date",
                      onChange: _ctx.handleChangeCarryContainerTime
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  _: 2
                }, 1032, ["label", "prop"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalStopAddress,
      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.modalStopAddress) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          modelValue: _ctx.formStopAddress,
          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formStopAddress) = $event)),
          ref: "ref-form-stop-address"
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'StopAddresses')
              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formStopAddress.Data.StopAddresses, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", { key: i }, [
                      _createVNode(_component_el_form_item, {
                        label: "详细地址",
                        prop: `StopAddresses[${i}].DetailAddress`,
                        rules: _ctx.formStopAddress.Rules.DetailAddress
                      }, {
                        label: _withCtx(() => [
                          (i > 0 && _ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_miezz_button, {
                                key: 0,
                                model: _ctx.btnDeleteStopAddress,
                                onHandleClick: 
                  (arg1, arg2) => _ctx.handleDeleteStopAddress(i, arg2)
                
                              }, null, 8, ["model", "onHandleClick"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, "详细地址 " + _toDisplayString(i + 1), 1)
                        ]),
                        default: _withCtx(() => [
                          (_ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_miezz_input, {
                                key: 0,
                                modelValue: item.DetailAddress,
                                "onUpdate:modelValue": ($event: any) => ((item.DetailAddress) = $event),
                                "fetch-suggestions": _ctx.getStopAddresses,
                                "trigger-on-focus": true,
                                clearable: "",
                                "value-key": "Value"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "fetch-suggestions"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(item.DetailAddress ?? "暂无数据"), 1))
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"]),
                      _createVNode(_component_el_form_item, {
                        label: "抵达时间",
                        prop: `StopAddresses[${i}].ArrivalTime`,
                        rules: _ctx.formStopAddress.Rules.ArrivalTime
                      }, {
                        default: _withCtx(() => [
                          (_ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_el_date_picker, {
                                key: 0,
                                modelValue: item.ArrivalTime,
                                "onUpdate:modelValue": ($event: any) => ((item.ArrivalTime) = $event),
                                type: "datetime",
                                format: "YYYY/MM/DD HH:mm",
                                "value-format": "YYYY/MM/DD HH:mm",
                                class: "form-item-date",
                                onChange: ($event: any) => (_ctx.handleChangeStopAddressArrivalTime(item))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(_ctx.formatTime(item.ArrivalTime)), 1))
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"]),
                      _createVNode(_component_el_form_item, {
                        label: "司机姓名",
                        prop: `StopAddresses[${i}].ArrivalDriverName`,
                        rules: _ctx.formStopAddress.Rules.ArrivalDriverName
                      }, {
                        default: _withCtx(() => [
                          (_ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_miezz_input, {
                                key: 0,
                                modelValue: item.ArrivalDriverName,
                                "onUpdate:modelValue": ($event: any) => ((item.ArrivalDriverName) = $event),
                                clearable: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(item.ArrivalDriverName ?? "暂无数据"), 1))
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"]),
                      _createVNode(_component_el_form_item, {
                        label: "车头号码",
                        prop: `StopAddresses[${i}].ArrivalHeadstockNumber`,
                        rules: _ctx.formStopAddress.Rules.ArrivalHeadstockNumber
                      }, {
                        default: _withCtx(() => [
                          (_ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_miezz_input, {
                                key: 0,
                                modelValue: item.ArrivalHeadstockNumber,
                                "onUpdate:modelValue": ($event: any) => ((item.ArrivalHeadstockNumber) = $event),
                                clearable: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(item.ArrivalHeadstockNumber ?? "暂无数据"), 1))
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"]),
                      _createVNode(_component_el_form_item, {
                        label: "车板号码",
                        prop: `StopAddresses[${i}].ArrivalCarBoardNumber`,
                        rules: _ctx.formStopAddress.Rules.ArrivalCarBoardNumber
                      }, {
                        default: _withCtx(() => [
                          (_ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_miezz_input, {
                                key: 0,
                                modelValue: item.ArrivalCarBoardNumber,
                                "onUpdate:modelValue": ($event: any) => ((item.ArrivalCarBoardNumber) = $event),
                                clearable: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(item.ArrivalCarBoardNumber ?? "暂无数据"), 1))
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"]),
                      _createVNode(_component_el_form_item, {
                        label: "备注",
                        prop: `StopAddresses[${i}].ArrivalRemark`,
                        rules: _ctx.formStopAddress.Rules.ArrivalRemark
                      }, {
                        default: _withCtx(() => [
                          (_ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_miezz_input, {
                                key: 0,
                                modelValue: item.ArrivalRemark,
                                "onUpdate:modelValue": ($event: any) => ((item.ArrivalRemark) = $event),
                                type: "textarea",
                                rows: 3,
                                trim: false
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(item.ArrivalRemark ?? "暂无数据"), 1))
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"]),
                      _createVNode(_component_el_form_item, {
                        label: "驶离时间",
                        prop: `StopAddresses[${i}].LeaveTime`,
                        rules: _ctx.formStopAddress.Rules.LeaveTime
                      }, {
                        default: _withCtx(() => [
                          (_ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_el_date_picker, {
                                key: 0,
                                modelValue: item.LeaveTime,
                                "onUpdate:modelValue": ($event: any) => ((item.LeaveTime) = $event),
                                type: "datetime",
                                format: "YYYY/MM/DD HH:mm",
                                "value-format": "YYYY/MM/DD HH:mm",
                                class: "form-item-date",
                                onChange: ($event: any) => (_ctx.handleChangeStopAddressLeaveTime(item))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(_ctx.formatTime(item.LeaveTime)), 1))
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"]),
                      _createVNode(_component_el_form_item, {
                        label: "司机姓名",
                        prop: `StopAddresses[${i}].LeaveDriverName`,
                        rules: _ctx.formStopAddress.Rules.LeaveDriverName
                      }, {
                        default: _withCtx(() => [
                          (_ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_miezz_input, {
                                key: 0,
                                modelValue: item.LeaveDriverName,
                                "onUpdate:modelValue": ($event: any) => ((item.LeaveDriverName) = $event),
                                clearable: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_63, _toDisplayString(item.LeaveDriverName ?? "暂无数据"), 1))
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"]),
                      _createVNode(_component_el_form_item, {
                        label: "车头号码",
                        prop: `StopAddresses[${i}].LeaveHeadstockNumber`,
                        rules: _ctx.formStopAddress.Rules.LeaveHeadstockNumber
                      }, {
                        default: _withCtx(() => [
                          (_ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_miezz_input, {
                                key: 0,
                                modelValue: item.LeaveHeadstockNumber,
                                "onUpdate:modelValue": ($event: any) => ((item.LeaveHeadstockNumber) = $event),
                                clearable: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_64, _toDisplayString(item.LeaveHeadstockNumber ?? "暂无数据"), 1))
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"]),
                      _createVNode(_component_el_form_item, {
                        label: "车板号码",
                        prop: `StopAddresses[${i}].LeaveCarBoardNumber`,
                        rules: _ctx.formStopAddress.Rules.LeaveCarBoardNumber
                      }, {
                        default: _withCtx(() => [
                          (_ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_miezz_input, {
                                key: 0,
                                modelValue: _ctx.formStopAddress.Data.LeaveCarBoardNumber,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formStopAddress.Data.LeaveCarBoardNumber) = $event)),
                                clearable: ""
                              }, null, 8, ["modelValue"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString(_ctx.formStopAddress.Data.LeaveCarBoardNumber ?? "暂无数据"), 1))
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"]),
                      _createVNode(_component_el_form_item, {
                        label: "备注",
                        prop: `StopAddresses[${i}].LeaveRemark`,
                        rules: _ctx.formStopAddress.Rules.LeaveRemark
                      }, {
                        default: _withCtx(() => [
                          (_ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_miezz_input, {
                                key: 0,
                                modelValue: item.LeaveRemark,
                                "onUpdate:modelValue": ($event: any) => ((item.LeaveRemark) = $event),
                                type: "textarea",
                                rows: 3,
                                trim: false
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_66, _toDisplayString(item.LeaveRemark ?? "暂无数据"), 1))
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"])
                    ]))
                  }), 128)),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      (_ctx.canEdit)
                        ? (_openBlock(), _createBlock(_component_miezz_button, {
                            key: 0,
                            model: _ctx.btnAddStopAddress,
                            onHandleClick: _ctx.handleTopButtonClick
                          }, null, 8, ["model", "onHandleClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalIntoPortWharf,
      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.modalIntoPortWharf) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          modelValue: _ctx.formIntoPortWharf,
          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.formIntoPortWharf) = $event)),
          ref: "ref-form-into-port-wharf"
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'IntoPortWharfLabel')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: item.Label,
                  prop: item.Prop
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_input, {
                      modelValue: _ctx.formIntoPortWharf.Data.IntoPortWharfLabel,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.formIntoPortWharf.Data.IntoPortWharfLabel) = $event)),
                      "fetch-suggestions": _ctx.getAreas,
                      "trigger-on-focus": true,
                      clearable: "",
                      valueKey: "FullName"
                    }, null, 8, ["modelValue", "fetch-suggestions"])
                  ]),
                  _: 2
                }, 1032, ["label", "prop"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalBackContainerTime,
      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.modalBackContainerTime) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          modelValue: _ctx.formBackContainerTime,
          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.formBackContainerTime) = $event)),
          ref: "ref-form-back-container-time"
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'BackContainerTime')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: item.Label,
                  prop: item.Prop
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.formBackContainerTime.Data.BackContainerTime,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.formBackContainerTime.Data.BackContainerTime) = $event)),
                      type: "datetime",
                      format: "YYYY/MM/DD HH:mm",
                      "value-format": "YYYY/MM/DD HH:mm",
                      class: "form-item-date",
                      onChange: _ctx.handleChangeBackContainerTime
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  _: 2
                }, 1032, ["label", "prop"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalContainerNo,
      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.modalContainerNo) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          modelValue: _ctx.formContainerNo,
          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.formContainerNo) = $event)),
          ref: "ref-form-container-no"
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'ContainerNo')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: item.Label,
                  prop: item.Prop
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_input, {
                      modelValue: _ctx.formContainerNo.Data.ContainerNo,
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.formContainerNo.Data.ContainerNo) = $event)),
                      pattern: "[0-9a-z]",
                      upperCase: true
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["label", "prop"]))
              : (item.Prop == 'Tare')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 1,
                    label: item.Label,
                    prop: item.Prop
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_miezz_input, {
                        modelValue: _ctx.formContainerNo.Data.Tare,
                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.formContainerNo.Data.Tare) = $event)),
                        pattern: "[0-9.]",
                        number: true,
                        numberFixed: 2,
                        greaterThanNumber: 0,
                        disabled: _ctx.formContainerNo.Data.TareDisabled
                      }, {
                        append: _withCtx(() => [
                          _createTextVNode(" KGS ")
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    _: 2
                  }, 1032, ["label", "prop"]))
                : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalSealNo,
      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.modalSealNo) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          modelValue: _ctx.formSealNo,
          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.formSealNo) = $event)),
          ref: "ref-form-seal-no"
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'SealNo')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: item.Label,
                  prop: item.Prop
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_input, {
                      modelValue: _ctx.formSealNo.Data.SealNo,
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.formSealNo.Data.SealNo) = $event)),
                      pattern: "[0-9a-z]",
                      upperCase: true
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["label", "prop"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalFile,
      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.modalFile) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          modelValue: _ctx.formFile,
          "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.formFile) = $event)),
          ref: "ref-form-file"
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'ContainerNoFile')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: `${item.Label}${_ctx.list.Data?.Items?.find(it => it.Id === _ctx.id)?.ContainerNo ? `（${_ctx.list.Data.Items.find(it => it.Id === _ctx.id)?.ContainerNo}）` : ''}`,
                  prop: item.Prop
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_upload, {
                      modelValue: _ctx.formFile.Data.ContainerNoFile,
                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.formFile.Data.ContainerNoFile) = $event)),
                      accept: "image/*",
                      path: "order/pool/container-trailer/container-no",
                      maxSize: 2 * 1024 * 1024,
                      preview: !_ctx.canEdit
                    }, null, 8, ["modelValue", "preview"])
                  ]),
                  _: 2
                }, 1032, ["label", "prop"]))
              : (item.Prop == 'SealNoFile')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 1,
                    label: `${item.Label}${_ctx.list.Data?.Items?.find(it => it.Id === _ctx.id)?.SealNo ? `（${_ctx.list.Data.Items.find(it => it.Id === _ctx.id)?.SealNo}）` : ''}`,
                    prop: item.Prop
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_miezz_upload, {
                        modelValue: _ctx.formFile.Data.SealNoFile,
                        "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.formFile.Data.SealNoFile) = $event)),
                        accept: "image/*",
                        path: "order/pool/container-trailer/seal-no",
                        maxSize: 2 * 1024 * 1024,
                        preview: !_ctx.canEdit
                      }, null, 8, ["modelValue", "preview"])
                    ]),
                    _: 2
                  }, 1032, ["label", "prop"]))
                : (item.Prop == 'Files')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      label: item.Label,
                      prop: item.Prop
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_upload, {
                          modelValue: _ctx.formFile.Data.Files,
                          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.formFile.Data.Files) = $event)),
                          path: "order/pool/container-trailer/file",
                          prop: "File",
                          maxSize: 2 * 1024 * 1024,
                          preview: !_ctx.canEdit
                        }, null, 8, ["modelValue", "preview"])
                      ]),
                      _: 2
                    }, 1032, ["label", "prop"]))
                  : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalAdd,
      "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.modalAdd) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.formAdd.Data,
          rules: _ctx.formAdd.Rules,
          "label-width": "150px",
          ref: "ref-form-add"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "委托人",
              prop: "ClientCompanyId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_select, {
                  modelValue: _ctx.formAdd.Data.ClientCompanyId,
                  "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.formAdd.Data.ClientCompanyId) = $event)),
                  options: _ctx.clients
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Booking No.",
              prop: "PoolId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_select, {
                  modelValue: _ctx.formAdd.Data.PoolId,
                  "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.formAdd.Data.PoolId) = $event)),
                  options: _ctx.bookingNos,
                  disabled: !_ctx.formAdd.Data.ClientCompanyId
                }, null, 8, ["modelValue", "options", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}